import { createFileRoute } from "@tanstack/react-router"
import { MemberPage } from "@/pages/MemberPage"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/members/$memberId/$tabKey"
)({
  component: () => (
    <AuthorizationGate resource={Resource.MEMBERSHIP} action={Action.READ}>
      <MemberPage />
    </AuthorizationGate>
  ),
})
